export enum RoutesEnum {
  ROOT = '/',
  CLIENTS = '/clients',
  TRANSPORTS = '/transports',
  TOOLS = '/tools',
  OFFERS = '/offers',
  CONTRACTS = '/contracts',
  SETTINGS = '/settings',
  TRANSPORT_SETTINGS = '/transportSettings',
  INBOX = '/inbox',
  USERS = '/users',
  NEW = '/new',
}
